import React, { Component } from 'react'
import { connect } from 'react-redux'
import Breakpoints from '../utils/Breakpoints'

import './ImageCarousel.scss';

class ImageCarousel extends Component {
  static defaultProps = {
    slides: [],
    glideOptions: {
      type: 'carousel',
      startAt: 0,
      autoplay: 4000,
      animationDuration: 600,
      animationTimingFunc: 'ease-in-out',
      gap: 0,
      focusAt: "center",
      rewind: 'infinite',
    },
  }

  // Lifecycle
  constructor(props) {
    super(props);
    this.state = {
      activeSlideIndex: this.getInitialSlideIndex(props),
    };
    this.autoplayTimer = null;
  }

  componentDidMount() {
    this.startAutoplay();
  }

  componentDidUpdate(prevProps) {
    const autoplayChanged = prevProps.glideOptions.autoplay !== this.props.glideOptions.autoplay;
    const startAtChanged = prevProps.glideOptions.startAt !== this.props.glideOptions.startAt;
    const slidesChanged = prevProps.slides !== this.props.slides;

    if (autoplayChanged || startAtChanged || slidesChanged) {
      this.clearAutoplay();
      this.setState(({ activeSlideIndex }) => ({
        activeSlideIndex: startAtChanged
          ? this.getInitialSlideIndex(this.props)
          : this.getSafeSlideIndex(activeSlideIndex),
      }), this.startAutoplay);
    }
  }

  componentWillUnmount() {
    this.clearAutoplay();
  }

  getInitialSlideIndex = (props) => {
    const startAt = Number(props.glideOptions.startAt) || 0;

    if (!props.slides.length) {
      return 0;
    }

    return startAt % props.slides.length;
  }

  getSafeSlideIndex = (index) => {
    const { slides } = this.props;

    if (!slides.length) {
      return 0;
    }

    return index % slides.length;
  }

  clearAutoplay = () => {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  startAutoplay = () => {
    const { slides } = this.props;
    const autoplayDelay = Number(this.props.glideOptions.autoplay);

    if (slides.length <= 1 || !autoplayDelay) {
      return;
    }

    this.autoplayTimer = setInterval(() => {
      this.setState(({ activeSlideIndex }) => ({
        activeSlideIndex: this.getSafeSlideIndex(activeSlideIndex + 1),
      }));
    }, autoplayDelay);
  }

  render() {
    const { 
      slides, 
      breakpoint,
      glideOptions,
    } = this.props;
    const isMobile = !Breakpoints.isDesktop(breakpoint);
    const { activeSlideIndex } = this.state;

    return (
      <div className='ImageCarousel'>
        <div
          className='ImageCarouselSlides'
          style={{
            '--image-carousel-duration': `${glideOptions.animationDuration}ms`,
            '--image-carousel-timing': glideOptions.animationTimingFunc,
          }}
        >
          {slides.map((slide, index) => (
            <div
              key={"slide-" + index}
              className={`ImageCarouselSlide${index === activeSlideIndex ? ' is-active' : ''}`}
              aria-hidden={index === activeSlideIndex ? 'false' : 'true'}
            >
              <img
                src={(isMobile ? slide.mobileSrc : slide.desktopSrc)}
                alt={slide.alt}
              />
            </div>
          ))}
        </div>
      </div>
    );
  }
}

// Redux Mapping
const mapStateToProps = (state) => ({
  breakpoint: state.AppReducer.breakpoint,
});
const mapDispatchToProps = (dispatch) => ({});
export default connect(mapStateToProps,mapDispatchToProps)(ImageCarousel);
